# Do NOT import this into an index.js file-- this is a real JS module

getDatetimeValue = (fid, fmt) ->
  el = $("##{fid}")
  if el.length > 0
    if el.data('DateTimePicker')?
      d = el.data('DateTimePicker').date()
      if d?
        d.format(fmt)
      else
        ""
    else
      ""
  else
    ""

getDateValue = (fid) ->
  getDatetimeValue(fid, 'YYYY-MM-DD')

getTimeValue = (fid) ->
  getDatetimeValue(fid, 'hh:mm A')

handleScheduleButton = (date, time, button) ->
  if button == 'hour'
    $(date).data('DateTimePicker').date(moment())
    QHOUR = 15 * 60 * 1000
    start = moment().add(1, 'h')
    start = moment(Math.round((+start) / QHOUR) * QHOUR)
    $(time).data('DateTimePicker').date(start)
  else if button == 'day'
    $(date).data('DateTimePicker').date(moment().add(1, 'd'))
    $(time).data('DateTimePicker').date(moment().hour(9).minute(0))
  else if button == 'week'
    $(date).data('DateTimePicker').date(moment().day(8))
    $(time).data('DateTimePicker').date(moment().hour(9).minute(0))

module.exports = {
  getDateValue: getDateValue
  getTimeValue: getTimeValue
  handleScheduleButton: handleScheduleButton
}